// Route guard for Learn authoring — allows content publishers and superadmins.
// gw enforces the same (LearnAdminService.requireAuthor).
import { useRole } from '../app/RoleContext';
import AccessDenied from './AccessDenied';

export default function RequireAuthor({ children }) {
  const { canSeeContentLibrary } = useRole();
  if (canSeeContentLibrary) return children;
  return (
    <AccessDenied title="Publisher access required">
      The content library is available to content publishers and superadmins. A
      superadmin can grant you the publisher role from the Members page.
    </AccessDenied>
  );
}
